import { useTranslation } from 'next-i18next'
import styles from './tags.module.scss';
import { memo } from 'react';

type TTags = {
  isRemote: number;
  workTimeStr: string;
  requiredWorkYearStr: string;
  requiredEducationStr: string;
};

export default memo(function Tags({ isRemote, workTimeStr, requiredWorkYearStr, requiredEducationStr }: TTags) {
  const { t } = useTranslation('common')
  
  return (
    <div className={`${styles.tags}`}>
      {isRemote === 1 ? (
        <span className={`${styles.tag} ${styles.highlight} truncate`}>
          { t('Remote') }
        </span>
      ) : ''}
      {workTimeStr ? (
        <span className={`${styles.tag} truncate`}>
          { workTimeStr }
        </span>
      ) : ''}
      {requiredWorkYearStr ? (
        <span className={`${styles.tag} truncate`}>
          { requiredWorkYearStr }
        </span>
      ) : ''}
      {requiredEducationStr ? (
        <span className={`${styles.tag} truncate`}>
          { requiredEducationStr }
        </span>
      ) : ''}
    </div>
  );
})
